export default "__VITE_ASSET__BigU8K6B__"